import {removeURLParams} from '../../../../shared/scripts/ui_utils/Utils'
import {ViewPopupLogin} from '../../../../shared/scripts/ui_popup/ui_popup_membership_incentive/ViewPopupLogin'
import {ErrorController} from '../../../../../shared/errors/ErrorController'
import {UIErrorHandler} from '../../../../shared/scripts/errors/UIErrorHandler'
import {UIHeaderController} from '../../../../shared/scripts/ui_html/header/UIHeaderController'
import {stripOAuthTokenFromUrl} from '../../../../shared/scripts/ui_utils/TestableClientUtils'

export class UIWHeaderController extends UIHeaderController {
    readonly container: HTMLHeadingElement

    constructor() {
        super()
        this.container = document.getElementById('page_header') as HTMLHeadingElement
        stripOAuthTokenFromUrl()

        UIWHeaderController.displayRedirectErrors()
        UIWHeaderController.displayLoginPopupBasedOnUrlSearchParams()
    }

    hide() {
        this.container.style.display = 'none'
    }

    show() {
        this.container.style.display = 'flex'
    }

    private static displayRedirectErrors() {
        const urlSearchParams = new URLSearchParams(window.location.search)

        const error = urlSearchParams.get('error')
        if(error == null) return

        const parsedError = JSON.parse(error)
        const deserializedError = ErrorController.deserializeErrorData(parsedError)

        UIErrorHandler.handleError(deserializedError)
        removeURLParams()
    }

    private static displayLoginPopupBasedOnUrlSearchParams() {
        const urlSearchParams = new URLSearchParams(window.location.search)
        if(!urlSearchParams.has('login-popup')) return

        new ViewPopupLogin()
        removeURLParams()
    }
}

